import React from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});
function RouteMap({ stations }) {
    if (!stations || stations.length === 0) {
        return null;
    }
    const avgLat = stations.reduce((sum, s) => sum + s.latitude, 0) / stations.length;
    const avgLng = stations.reduce((sum, s) => sum + s.longitude, 0) / stations.length;
    const center = [avgLat, avgLng];
    return (
        <MapContainer center={center} zoom={11} style={{height: '400px', width: '100%'}}>
            <TileLayer
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                attribution='© OpenStreetMap contributors'
            />
            {stations.map((station, index) => (
                <Marker key={index} position={[station.latitude, station.longitude]}>
                    <Popup>
                        <b>{station.stationName}</b><br/>
                        €{station.fuelPrice}/L<br/>
                        {station.detourTimeMinutes} min detour
                    </Popup>
                </Marker>
            ))}
        </MapContainer>
    );
}
export default RouteMap;